module.exports = __webpack_public_path__ + "static/img/rys4.b104d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rys4.png
// module id = E+5g
// module chunks = 1